import React from 'react'
import { ThemeContext } from 'styled-components'

// Updated function with a higher threshold to reduce overlaps
export const renderCustomPieChartLabel = ({
  cx,
  cy,
  x,
  y,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  value,
  index,
  theme,
  ...props
}) => {
  // Increased threshold to filter out smaller slices that often cause overlaps
  if (percent < 0.03) return null

  const fillColor = theme?.dashboard?.metric || 'white'

  // Using textAnchor="middle" for consistent positioning
  return (
    <text
      x={x}
      y={y}
      fontSize={14}
      fill={fillColor}
      textAnchor="middle"
      dominantBaseline="central"
    >
      {`${parseInt(percent * 100)}%`}
    </text>
  )
}

// Keep the existing labelLine function with matching threshold
export const renderCustomPieChartLabelLine = ({ points, percent, theme }) => {
  let path = ''
  if (percent < 0.03) return null
  points.forEach((point, index) => {
    path += `${point.x},${point.y} `
  })

  const strokeColor = theme?.dashboard?.metricTitle || 'white'

  return <polyline points={path} stroke={strokeColor} fill="none" />
}

// Custom label: white font, percent only, hide if <2%, position further out
export const renderWhitePiePercentLabel = ({
  percent,
  cx,
  cy,
  midAngle,
  outerRadius
}) => {
  if (percent < 0.02) return null
  const RADIAN = Math.PI / 180
  const radius = outerRadius * 1.75
  const x = cx + radius * Math.cos(-midAngle * RADIAN)
  const y = cy + radius * Math.sin(-midAngle * RADIAN)
  return (
    <text
      x={x}
      y={y}
      fontSize={14}
      fill="#fff"
      textAnchor="middle"
      dominantBaseline="central"
    >
      {`${Math.round(percent * 100)}%`}
    </text>
  )
}

// Custom label line: white, hide if <2%
export const renderWhitePieLabelLine = ({ points, percent }) => {
  if (percent < 0.02) return null
  const path = points.map(p => `${p.x},${p.y}`).join(' ')
  return <polyline points={path} stroke="#fff" fill="none" strokeWidth={1.5} />
}
